import * as React from "react"
import { connect } from 'react-redux'
import {
    updateInputValue as change,
} from "app/reducers/form";
import { SettingsFormType } from "app/types/model-types";
import { selectFormValues } from "app/reducers/form";

import {
    css,
    Grid,
    GridCell,
    Toggler,
} from "@bdfx/mergado-ui-kit";

import trans from "trans";

interface Props {
    change: typeof change
    settingsForm: SettingsFormType
    saveSettingsDebounced: Function
}

interface State {
}

class VisualSimilarity extends React.Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        return <StyledGrid cols="auto">
            <GridCell>{trans('fill_similarity_title')}</GridCell>
            <GridCell>
                <Toggler
                    big={true}
                    boolean={true}
                    name={`settingsForm.similarity_ids_element`}
                    onLabel={trans('fill_similarity_ids_element')}
                    title={trans('fill_similarity_ids_element')}
                    onChange={() => this.props.saveSettingsDebounced()}
                />
            </GridCell>
            <GridCell>
                <Toggler
                    big={true}
                    boolean={true}
                    name={`settingsForm.similarity_image_urls_element`}
                    onLabel={trans('fill_similarity_image_urls_element')}
                    title={trans('fill_similarity_image_urls_element')}
                    onChange={() => this.props.saveSettingsDebounced()}
                />
            </GridCell>
        </StyledGrid>
    }
}

const StyledGrid = css(Grid)({
    padding: '20px',
    gridRowGap: '10px',
    textAlign: 'left',
    ' .padding': {
        padding: '3px',
    }
})

function mapStateToProps(state) {
    return {
        settingsForm: selectFormValues(state, 'settingsForm'),
    }
}

export default connect(mapStateToProps, {
    change,
})(VisualSimilarity)